<template>
  <div>
    <Dialog v-model:visible="visible" modal :closable="false" header="Select Data to Analyze" :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <Message v-if="conversationThresholdExceeded" :closable="false" severity="warn"> You can analyze maximum 500 conversations. Consider refining your filters.</Message>
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2">
          <RadioButton v-model="daData" inputId="rbSummary" name="convData" value="summary" />
          <label for="rbSummary">Summary</label>
        </div>
        <small id="rbSummary-help">Analyze Summaries of the Conversations</small>
      </div>
      <div class="mt-4 flex flex-col gap-2">
        <div class="flex items-center gap-2">
          <RadioButton v-model="daData" inputId="rbTranscript" name="convData" value="transcript" />
          <label for="rbTranscript">Transcript</label>
        </div>
        <small id="rbTranscript-help">Analyze Transcripts of the Conversations</small>
      </div>
      <div class="mt-4">
        <small class="min-h-6 block">{{ progressText }} </small>
        <ProgressBar :mode="progressMode" style="height: 6px"></ProgressBar>
      </div>
      <template #footer>
        <Button label="Cancel" :disabled="showProgress" severity="secondary" @click="visible = false" autofocus />
        <Button label="Analyze" :disabled="showProgress" severity="primary" @click="onAnalyze" autofocus />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
  import { ref, nextTick, computed } from 'vue';
  import InputText from 'primevue/inputtext';
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import ProgressBar from 'primevue/progressbar';
  import RadioButton from 'primevue/radiobutton';
  import Message from 'primevue/message';

  const visible = ref(false);
  const showProgress = ref(false);
  const progressMode = computed(() => (showProgress.value ? 'indeterminate' : ''));
  const progressText = ref('');

  const conversationThresholdExceeded = ref(false);
  const daData = ref('summary');

  const emit = defineEmits(['dataSelected']);

  function start(conversationsTotal) {
    conversationThresholdExceeded.value = conversationsTotal > 500;
    visible.value = true;
  }

  const pause = (x) => new Promise((res) => setTimeout(res, x));

  function onAnalyze() {
    emit('dataSelected', {
      dataType: daData.value,
    });
    visible.value = false;
  }

  defineExpose({ start });
</script>
